<template>
  <modal ref='modal'>
    <template #header>
      <h5 v-if='checklistItems.length > 1' class="modal-title mt-0">{{ $t('checklist.copy_items_to_folder')}}</h5>
      <h5 v-else class="modal-title mt-0">{{ $t('checklist.single_copy')}}</h5>
    </template>

    <template #body>
      <form>
        <div class='modal-body'>
          <div class="form-group">
            <label>
              {{ $t('checklist.select_folders')}}
            </label>
            <multi-select :template='folderTemplate' :getter='getFolders' v-model='selectedFolders' />
          </div>
        </div>

        <div class='modal-footer copy-items-footer'>
          <div>
            <label class="checkbox-container" v-if="hasRecords">
              <input type="checkbox" name="has-records" v-model="willCopyRecords">
              <span class="checkmark"></span>
              {{ $t('checklist.move_files') }}
            </label>
          </div>

          <button type='submit' class="btn btn-outline-primary" :disabled='!canCopy' @click.prevent="copy">
            {{ $t('checklist.copy', { count: checklistItemIds.length }) }}
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import modal from "../_modal"
  import _multi_select from "../shared/_infinite_multi_select"

  export default {
    components: {
      modal,
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        willCopyRecords: false,
        selectedFolders: [],
        checklistItems: [],
      }
    },
    computed: {
      selectedIds() {
        return this.selectedFolders.map(f => f.id)
      },
      canCopy() {
        return this.selectedFolders.length > 0
      },
      checklistItemIds() {
        return this.checklistItems.map(c => c.id)
      },
      hasRecords() {
        return this.checklistItems.some(c => c.record.id)
      }
    },
    methods: {
      getFolders(params) {
        return this.listStore.getFolders(params)
      },
      open(checklistItems) {
        this.willCopyRecords = false
        this.selectedFolders = []
        this.checklistItems = checklistItems

        this.$refs.modal.open()
      },
      copy() {
        const params = { new_folders: this.selectedIds , copy_records: this.willCopyRecords}

        this.store.executeBulkOperation('copy', this.checklistItemIds, params).then(() => {
          this.store.sendMetrics({name: 'bulk_copy_operation', params: this.$route.params, path: this.$route.fullPath})
          this.$refs.modal.close()
          this.$emit('success')
          this.$toastr.success(this.$t('checklist.checklist_updated'))
        })
      },
    },
  }
</script>
<style lang="sass" scoped>
  .copy-items-footer
    justify-content: space-between
    align-items: flex-start
    div
      width: 62%
  .custom-select
    width: 100%
</style>
